import {INTERACTION_ID} from './symbols';
import validateMeta from './validateMeta';

/**
 * Retrieves the interactionId from an action
 * @function getInteractionId
 * @example
 * import {getInteractionId} from '@servicenow/ui-metrics';
 *
 * const captureClickEvent = (coeffects, target) => {
 * 	 const {action, host} = coeffects;
 *
 *   mark(host, getInteractionId(action.meta), 'CLICK_EVENT', {eventTarget: target});
 * }
 *
 * @param {Object} meta - The meta data from the action object
 */
export default function getInteractionId(meta) {
	validateMeta(meta, 'getInteractionId');
	return meta[INTERACTION_ID];
}
